var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27568 15.2219C11.5738 14.7754 13.3087 12.752 13.3087 10.3233C13.3087 7.56724 11.0745 5.33301 8.31842 5.33301C5.56236 5.33301 3.32812 7.56724 3.32812 10.3233C3.32812 12.7976 5.12893 14.8514 7.49141 15.2454V17.2281H5.11239V19.0024H7.49141V21.3914H9.27568V19.0024H11.6547V17.2281H9.27568V15.2219ZM8.31728 13.761C10.2159 13.761 11.755 12.2219 11.755 10.3233C11.755 8.42465 10.2159 6.88552 8.31728 6.88552C6.41866 6.88552 4.87952 8.42465 4.87952 10.3233C4.87952 12.2219 6.41866 13.761 8.31728 13.761Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7475 11.8088C16.4657 12.2499 14.7326 14.2474 14.7099 16.6615C14.684 19.4174 16.8972 21.6725 19.6531 21.6984C22.4091 21.7243 24.6642 19.5112 24.6901 16.7552C24.7135 14.2632 22.9061 12.1806 20.5222 11.7855L20.5651 7.21536L18.7909 7.19869L18.7475 11.8088ZM16.262 16.6757C16.2798 14.7772 17.8334 13.2526 19.7319 13.2704C21.6305 13.2883 23.1551 14.8418 23.1372 16.7403C23.1194 18.6389 21.5659 20.1635 19.6673 20.1456C17.7688 20.1278 16.2442 18.5743 16.262 16.6757Z",
    fill: "#37383A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5651 8.34131L19.8249 5.33295L22.8332 8.59275L21.6924 9.64555L19.7369 7.52655L17.6179 9.48211L16.5651 8.34131Z",
    fill: "#37383A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33191 6.34059C10.2768 6.34059 12.3307 8.38773 12.3307 11.3333L10.6706 11.3332C10.6706 9.30409 9.35936 7.99982 7.33069 7.99982L7.33191 6.34059Z",
    fill: "#37383A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3295 20.9927C17.3846 20.9927 15.3306 18.9456 15.3306 16.0001L16.9907 16.0001C16.9907 18.0292 18.302 19.3335 20.3307 19.3335L20.3295 20.9927Z",
    fill: "#ADADAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/Gender.994b6c384eefe705631245427c6c8ebc.svg";
export { ForwardRef as ReactComponent };